// src/pages/DespreMine.jsx
import React from "react";
import { motion } from "framer-motion";
import Title from "../components/ui/Title";
import AboutCard from "../components/ui/AboutCard";
import CoreValues from "../components/ui/CoreValues";

export default function DespreMine() {
  return (
    <motion.div
      className="p-6 max-w-3xl mx-auto space-y-8 text-text-body"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <Title>Despre mine</Title>

      <AboutCard
        image="/corina_mandala_rave.png"
        name="Corina Nedelcu"
        role="Bodygraph-ul meu în Human Design"
        description="Generator Manifestant, Profil 6/2, Crucea Vindecării (2) (VS)"
      />

      <div className="space-y-4 text-base leading-relaxed">
        <p>
          Mă numesc Corina și am învățat să onorez nu doar ceea ce știu, ci ceea ce trăiesc. Sunt <strong>Generator Manifestant</strong> cu <strong>Profil 6/2</strong>, purtătoare a <strong>Crucii Încarnării Vindecării (VS)</strong>.
        </p>
        <p>
          Vitalitatea mea izvorăște din presiunea de a mă pune în serviciu, împărtășind o direcție viitoare bazată pe experiența de a persevera în dificultăți. În Human Design am găsit o hartă vie, dar mai ales un drum de întoarcere spre sine.
        </p>
        <p>
          Nu sunt doar un cititor de Bodygraph-uri. Integrez, trăiesc, ascult. Fiecare revelație se întrupează în viața mea înainte de a fi oferită altcuiva. Aici, în acest spațiu, adevărul nu este o formulă. Este o prezență. Este o invitație.
        </p>
        <p>
          Cred într-un <strong>Human Design curat</strong> – fără junk, fără deturnări. Cred într-o <strong>vindecare tihnită</strong>, dar temeinică. Iar acest site e, poate, jurnalul viu al unei ființe care a ales să trăiască designul, nu doar să-l înțeleagă.
        </p>
      </div>

      <CoreValues />
    </motion.div>
  );
}